import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import styles from "./SearchButton.module.scss";

interface ClearSearchProps {
    onClear: () => void;
    className?: string;
}

export const ClearSearchButton = ({ onClear, className }: ClearSearchProps) => (
    <Button
        onClick={onClear}
        icon={IconCollection.close}
        variation="white"
        label="Clear"
        className={`${styles.clearSearchButton} ${className}`}
    />
);
